import { markQuotationForProccessing } from '../../../features/insuranceRequests/insuranceRequestsActions';
import { SaveQuoteButton } from '../PurchaseV2.styles';

export function SaveBox({
  insuranceRequest,
  quotationId,
  refresh,
}) {
  const caller = () => {
    markQuotationForProccessing(quotationId, refresh);
  };

  if (insuranceRequest.processing_quotation_id === quotationId) {
    return null;
  }

  return <SaveQuoteButton type="button" onClick={caller}>Salva il preventivo</SaveQuoteButton>;
}
